import { useThemeContext } from "../../context/ThemeContext";
import { content } from "../../data/content";

import { SectionDivider } from "../../components/SectionDivider/SectionDivider";
import { Breadcrumb } from "../../components/Breadcrumb/Breadcrumb";
import { Stack } from "../../components/Stack/Stack";
import { DetailsCard } from "../../components/Card/DetailsCard/DetailsCard";

import styles from "./AboutPage.module.scss";

export function AboutPage() {
  const theme = useThemeContext();
  const c = content;

  return (
    <>
      <section className={styles.hero}>
        <Breadcrumb
          theme={theme}
          breadcrumbs={[
            ["home", "home"],
            ["about", "about"],
          ]}
        />
        <h1 className={styles.h1} style={{ color: theme.fg }}>
          /about
        </h1>
        <p className={styles.lede} style={{ color: theme.muted }}>
          A slightly longer version of "what does this person actually do."
          Still trying to keep it under 600 words.
        </p>
      </section>

      <SectionDivider theme={theme} label="who" />
      <section className={styles.grid}>
        <article className={styles.article}>
          {c.aboutLong.map((para, i) => (
            <p
              key={i}
              className={styles.para}
              style={{ color: theme.fg, opacity: i === 0 ? 1 : 0.88 }}
            >
              {para}
            </p>
          ))}
        </article>

        <aside className={styles.aside}>
          <DetailsCard
            label="at a glance"
            labelType="free"
            variant="rows"
            rows={{
              role: "Junior Frontend Developer",
              pronouns: "she/her",
              based: "Koblenz",
              status: "Currently employed",
              since: "January 2023",
            }}
          />
          <Stack card />
          <DetailsCard
            label="reading"
            labelType="free"
            variant="list"
            items={[
              {
                title: "The Design of Everyday Things",
                subtitle: "Don, Norman",
              },
              {
                title: "Don't make me think!",
                subtitle: "Krug, Steve",
              },
              {
                title: "Laws of UX",
                subtitle: "Yablonski, Jon",
              },
            ]}
          />
        </aside>
      </section>
    </>
  );
}
